
/* injects from baggage-loader */

'use strict';

// import calisto from '_images/persons/calisto.png';
// import calistoThumb from '_images/calisto-thumb.png';


export default class StagesController {
	constructor($log, $state, Dialog, Session) {
		'ngInject';
		this.$log = $log;
		this.Session = Session;
		this.$state = $state;
		this.Dialog = Dialog;


		this.dataIntro = {
			// person: calisto,
			// thumb: calistoThumb,
			nextStep: () => {
				this.Session.dialog();
				// this.$state.go("main");
				this.$state.go('list-editor');
			},
			text: "​Parabéns! Você terminou o Desafio das listas. Agora você pode aplicar o que aprendeu para criar suas próprias listas no <b>Editor de listas​!</b>"
		};
	}

	dialogDesafio(){
		return (this.Session.get().dialogDesafio+!this.Session.get().desafioUnlocked)>1;
	}

	$onInit() {
		this.stages = this.Session.get().stages;
		let totalStars = 0;
		this.stages.forEach(s => { totalStars+=s.stars; });

		if(this.stages[0].stars===3 && !this.stages[0].unlockedTrophie){
			this.Session.trophieUnlocked(0);
			this.Dialog.showTrophiesModal(1);					
		} else if (this.stages[3].stars===3 && !this.stages[3].unlockedTrophie){
			this.Session.trophieUnlocked(3);
			this.Dialog.showTrophiesModal(1);			
		} else if (this.stages[6].stars===3 && !this.stages[6].unlockedTrophie){
			if(totalStars === 21){
				this.Session.trophieUnlocked(1);
				this.Session.trophieUnlocked(6);
				this.Dialog.showTrophiesModal(1,this.Dialog.showTrophiesModal(1));	
			} else{
				this.Session.trophieUnlocked(6);
				this.stages[6].unlockedTrophie = true;								
			}	
		} else if(totalStars === 21 && !this.stages[1].unlockedTrophie){
			this.Dialog.showTrophiesModal(1);
			this.Session.trophieUnlocked(1);
		}
	}

	onDrop(event, data, value){
		this.$log.debug(event, data, value);
	}
}


// WEBPACK FOOTER //
// ./src/app/pages/stages/stages.controller.js